/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Custom code to handle inline discount label with price
document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant;

  // Find the price list wrapper container
  var priceListWrapper = document.querySelector('.price-list-wrapper.price-list--with-discount');
  if (!priceListWrapper) return;

  // Find or create the discount label
  var discountLabel = priceListWrapper.querySelector('.product-label--on-sale');

  // Check if variant has a discount
  if (variant && variant.compare_at_price && variant.price < variant.compare_at_price) {
    // Calculate savings
    var savings;
    if (window.theme.discountMode === 'percentage') {
      savings = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price) + '%';
    } else {
      var savingsAmount = Currency.formatMoney(variant.compare_at_price - variant.price, window.theme.moneyFormat);
      savings = '<span>' + savingsAmount + '</span>';
    }

    // If discount label doesn't exist, create it
    if (!discountLabel) {
      discountLabel = document.createElement('span');
      discountLabel.className = 'product-label product-label--on-sale product-label--inline';
      priceListWrapper.appendChild(discountLabel);
    }

    // Update the discount label text
    discountLabel.innerHTML = window.languages.collectionOnSaleLabel.replace('{{savings}}', savings);
    discountLabel.style.display = 'inline-block';
  } else {
    // Hide discount label if no discount
    if (discountLabel) {
      discountLabel.style.display = 'none';
    }
  }
});


/* ============================================================
   FILTER BAR — Steel + Price
   ============================================================ */
(function() {
  function initFilters() {
    var bar = document.getElementById('ks-filter-bar');
    if (!bar) return;

    var steelBtns = document.querySelectorAll('.ks-steel-btn');
    var priceMin  = document.getElementById('ks-price-min');
    var priceMax  = document.getElementById('ks-price-max');
    var resetBtn  = document.getElementById('ks-filter-reset');
    var products  = document.querySelectorAll('#ks-product-list .product-item');

    var activeSteels = new Set();

    function applyFilters() {
      var minVal = priceMin.value !== '' ? parseInt(priceMin.value) : null;
      var maxVal = priceMax.value !== '' ? parseInt(priceMax.value) : null;

      products.forEach(function(item) {
        var steel = item.getAttribute('data-steel') || '';
        var price = parseInt(item.getAttribute('data-price')) || 0;

        var steelOk = activeSteels.size === 0 || activeSteels.has('') || activeSteels.has(steel);
        var priceOk = (minVal === null || price >= minVal) && (maxVal === null || price <= maxVal);

        if (steelOk && priceOk) {
          item.classList.remove('product-item--hidden');
        } else {
          item.classList.add('product-item--hidden');
        }
      });
    }

    steelBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var val = btn.getAttribute('data-steel');
        if (val === '') {
          // "All" → reset steel filter
          steelBtns.forEach(function(b) { b.classList.remove('active'); });
          btn.classList.add('active');
          activeSteels.clear();
        } else {
          // Toggle individual steel
          document.querySelector('.ks-steel-btn[data-steel=""]').classList.remove('active');
          if (activeSteels.has(val)) {
            activeSteels.delete(val);
            btn.classList.remove('active');
            if (activeSteels.size === 0) {
              document.querySelector('.ks-steel-btn[data-steel=""]').classList.add('active');
            }
          } else {
            activeSteels.add(val);
            btn.classList.add('active');
          }
        }
        applyFilters();
      });
    });

    priceMin.addEventListener('input', applyFilters);
    priceMax.addEventListener('input', applyFilters);

    resetBtn.addEventListener('click', function() {
      activeSteels.clear();
      steelBtns.forEach(function(b) { b.classList.remove('active'); });
      document.querySelector('.ks-steel-btn[data-steel=""]').classList.add('active');
      priceMin.value = '';
      priceMax.value = '';
      applyFilters();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilters);
  } else {
    initFilters();
  }
})();

/* ============================================================
   FILTER DROPDOWNS — un seul ouvert à la fois (desktop)
   ============================================================ */
(function() {
  function initFilterDropdowns() {
    var bar = document.querySelector('.layout--collection-filters .collection__filter-group-list');
    if (!bar) return;

    var btns = bar.querySelectorAll('.collection__filter-group-name');
    btns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var isExpanded = btn.getAttribute('aria-expanded') === 'true';
        // Fermer tous les autres
        btns.forEach(function(other) {
          if (other !== btn && other.getAttribute('aria-expanded') === 'true') {
            other.click(); // utilise le toggle natif du thème
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilterDropdowns);
  } else {
    initFilterDropdowns();
  }
})();
